import { ICurrency } from '../../types/currency';
import { SET_CURRENCY } from './constants';

export const setCurrencyAction = (currency: ICurrency) => ({
  type: SET_CURRENCY,
  payload: { currency },
});
